import { render, staticRenderFns } from "./tech-item.vue?vue&type=template&id=c0d83008&scoped=true&"
import script from "./tech-item.vue?vue&type=script&lang=js&"
export * from "./tech-item.vue?vue&type=script&lang=js&"
import style0 from "./tech-item.vue?vue&type=style&index=0&id=c0d83008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d83008",
  null
  
)

export default component.exports